var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7509 2.45031C11.4509 1.86031 12.5809 1.86031 13.2609 2.45031L14.8409 3.80031C15.1409 4.05031 15.7109 4.26031 16.1109 4.26031H17.8109C18.8709 4.26031 19.7409 5.13031 19.7409 6.19031V7.89031C19.7409 8.29031 19.9509 8.85031 20.2009 9.15031L21.5509 10.7303C22.1409 11.4303 22.1409 12.5603 21.5509 13.2403L20.2009 14.8203C19.9509 15.1203 19.7409 15.6803 19.7409 16.0803V17.7803C19.7409 18.8403 18.8709 19.7103 17.8109 19.7103H16.1109C15.7109 19.7103 15.1509 19.9203 14.8509 20.1703L13.2709 21.5203C12.5709 22.1103 11.4409 22.1103 10.7609 21.5203L9.18086 20.1703C8.88086 19.9203 8.31086 19.7103 7.92086 19.7103H6.17086C5.11086 19.7103 4.24086 18.8403 4.24086 17.7803V16.0703C4.24086 15.6803 4.04086 15.1103 3.79086 14.8203L2.44086 13.2303C1.86086 12.5403 1.86086 11.4203 2.44086 10.7303L3.79086 9.14031C4.04086 8.84031 4.24086 8.28031 4.24086 7.89031V6.20031C4.24086 5.14031 5.11086 4.27031 6.17086 4.27031H7.90086C8.30086 4.27031 8.86086 4.06031 9.16086 3.81031L10.7509 2.45031Z",
    stroke: "#0996CE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.12988V12.9599",
    stroke: "#0996CE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9941 16H12.0031",
    stroke: "#0996CE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.db5d7dcfccdb9bdce09006b5c8fb66c2.svg";
export { ForwardRef as ReactComponent };